import { createSlice } from "@reduxjs/toolkit";

const stepSlice = createSlice({
  name: "step",
  initialState: 1,
  reducers: {
    setStep: (state, action) => action.payload,
    nextStep: (state) => state + 1,
    prevStep: (state) => (state > 1 ? state - 1 : 1),
    resetStep: () => 1,
  },
});

export const { setStep, nextStep, prevStep, resetStep } = stepSlice.actions;
export default stepSlice.reducer;
